// @flow
import React, { useState, useEffect, useContext } from 'react';
import { useDispatch } from 'react-redux';
import SidePane from 'esm-web-pro/components/layout/SidePane';
import { Box } from 'grommet';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import { closePanel } from 'esm-web-pro/redux/side-panel';
import ApiClient from 'speed-js-core/src/api/ApiClient';
import { connectAPI } from 'speed-js-react';
import { Formik } from 'formik';
import { CheckboxContext } from 'esm-web-pro/containers/pages/projects/mapobjects/checkbox/CheckboxContext';
import { isEmpty } from 'lodash';
import ActionButtons from 'esm-web-pro/components/forms/ActionButtons';
import BaseSelect from 'esm-web-pro/components/forms/fields/BaseSelect';

export const GISPOINT_GROUPACTIONS_SIDEPANEL = 'GISPOINT_GROUPACTIONS_SIDEPANEL';

type Props = {
    project: String,
    reload: Function,
    getData: Function,
    updateMapObjects: Function,
    getObjectType: Function,
};

const messages = defineMessages({
    groupActions: {
        id: 'map-objects-group-actions',
        defaultMessage: 'Group Actions',
    },
});

const GroupActionsSidePanel = (props: Props) => {
    const {
        project, reload, getData, updateMapObjects, getObjectType,
    } = props;

    const [choices, setChoices] = useState(null);

    const [stage, setStage] = useState(null);

    const { selected, setSelected, onSelectAll } = useContext(CheckboxContext);

    const formRef = React.useRef();
    const { formatMessage } = useIntl();
    const dispatch = useDispatch();

    // Get Choices for updating Stage
    const extractChoices = (object) => {
        let stageChoice = {};
        object.results.forEach((result) => {
            const { id, name } = result;
            stageChoice = { ...stageChoice, [id]: name };
        });
        setChoices({ ...stageChoice });
    };

    useEffect(() => {
        getData(project)
            .then((res) => extractChoices(res))
            .catch((err) => console.log(err));
    }, []);

    const onChange = (value) => {
        if (value) {
            setStage(value);
        }
    };

    const onClose = () => {
        dispatch(closePanel(GISPOINT_GROUPACTIONS_SIDEPANEL, true));
        reload();
    };

    const onSubmit = () => {
        if (!isEmpty(selected) && stage) {
            const selectedArray = Object.values(selected);
            const uuids = selectedArray.map((object) => object.original.uuid);
            const type = getObjectType(selectedArray[0].original);
            const data = {
                type,
                uuids,
                project_stage: +stage,
            };
            updateMapObjects(data)
                .then(() => {
                    setSelected({});
                    dispatch(closePanel(GISPOINT_GROUPACTIONS_SIDEPANEL, true));
                    onSelectAll(false);
                    reload();
                })
                .catch((err) => console.log(err));
        }
    };

    return (
        <SidePane
            id={GISPOINT_GROUPACTIONS_SIDEPANEL}
            title={formatMessage(messages.groupActions)}
            closeAllOpened
        >
            <Box width="100%" pad={{ horizontal: 'medium' }}>
                <Formik ref={formRef}>
                    <BaseSelect
                        minWidth="100%"
                        onChange={(value) => onChange(value)}
                        emptyLabel={(
                            <FormattedMessage
                                id="map-objects-choose-group-action"
                                defaultMessage="Choose group action"
                            />
                        )}
                        value={stage}
                        choices={choices}
                    />
                </Formik>
            </Box>
            <Box style={{ height: '60px' }}>
                <ActionButtons
                    onSave={onSubmit}
                    onClose={onClose}
                />
            </Box>
        </SidePane>
    );
};

const apiCallback = (apiClient: ApiClient) => ({
    getData: {
        send: (uuid) => apiClient.resources.projectsStageNested.list(uuid),
        success: (res) => res.data,
        error: (err) => console.log(err),
    },
    updateMapObjects: {
        send: (data) => apiClient.resources.groupActions.changeStage(data),
    },
});

export default connectAPI(apiCallback)(GroupActionsSidePanel);
